import React from 'react';
import { ScrollElement } from 'site-modules/shared/components/scroll-link/scroll-element';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export function VdpGroup({ groupId, groupTitle = '', children = null, className = '' }) {
  return (
    <ScrollElement id={groupId} className={classNames('vdp-group', className)}>
      {groupTitle && <h2 className="heading-3 mb-1_5">{groupTitle}</h2>}
      {children}
    </ScrollElement>
  );
}

VdpGroup.propTypes = {
  groupId: PropTypes.string.isRequired,
  groupTitle: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};
